import { 
  collection, 
  addDoc, 
  query, 
  where, 
  orderBy, 
  getDocs, 
  deleteDoc,
  updateDoc,
  doc,
  Timestamp 
} from 'firebase/firestore';
import { db } from '../firebase';

// セルフケア記録を保存
export async function saveCareRecord(userId, recordData) {
  try {
    const docData = {
      userId,
      timestamp: recordData.customTimestamp ? Timestamp.fromDate(recordData.customTimestamp) : Timestamp.now(),
      feeling: recordData.feeling,
      content_type: recordData.content_type,
      tags: recordData.tags,
      note: recordData.note,
      createdAt: Timestamp.now()
    };

    // 所要時間が指定されている場合のみ追加
    if (recordData.duration !== undefined && recordData.duration !== null) {
      docData.duration = recordData.duration;
    }

    // 時刻不明フラグが指定されている場合は追加
    if (recordData.timeUnknown !== undefined) {
      docData.timeUnknown = recordData.timeUnknown;
    }

    const docRef = await addDoc(collection(db, 'care_records'), docData);
    return docRef.id;
  } catch (error) {
    console.error('記録保存エラー:', error);
    throw error;
  }
}

// ユーザーの記録を取得
export async function getCareRecords(userId, limit = 50) {
  try {
    const q = query(
      collection(db, 'care_records'),
      where('userId', '==', userId)
    );
    
    if (limit) {
      // limitを追加する場合は別途importが必要
    }
    
    const querySnapshot = await getDocs(q);
    const records = [];
    
    querySnapshot.forEach((doc) => {
      records.push({
        id: doc.id,
        ...doc.data(),
        timestamp: doc.data().timestamp.toDate(),
        createdAt: doc.data().createdAt?.toDate()
      });
    });
    
    return records;
  } catch (error) {
    console.error('記録取得エラー:', error);
    throw error;
  }
}

// 記録を削除
export async function deleteCareRecord(recordId) {
  try {
    await deleteDoc(doc(db, 'care_records', recordId));
  } catch (error) {
    console.error('記録削除エラー:', error);
    throw error;
  }
}

// 記録を更新
export async function updateCareRecord(recordId, recordData) {
  try {
    const docData = {
      feeling: recordData.feeling,
      content_type: recordData.content_type,
      tags: recordData.tags,
      note: recordData.note,
      updatedAt: Timestamp.now()
    };

    // 所要時間が指定されている場合のみ追加
    if (recordData.duration !== undefined && recordData.duration !== null) {
      docData.duration = recordData.duration;
    }

    // 日時が指定されている場合は更新
    if (recordData.customTimestamp) {
      docData.timestamp = Timestamp.fromDate(recordData.customTimestamp);
    }

    // 時刻不明フラグが指定されている場合は追加
    if (recordData.timeUnknown !== undefined) {
      docData.timeUnknown = recordData.timeUnknown;
    }

    await updateDoc(doc(db, 'care_records', recordId), docData);
    return recordId;
  } catch (error) {
    console.error('記録更新エラー:', error);
    throw error;
  }
}

// 月別の統計データを取得
export async function getMonthlyStats(userId, year, month) {
  try {
    const startDate = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0, 23, 59, 59);
    
    const q = query(
      collection(db, 'care_records'),
      where('userId', '==', userId),
      where('timestamp', '>=', Timestamp.fromDate(startDate)),
      where('timestamp', '<=', Timestamp.fromDate(endDate))
    );
    
    const querySnapshot = await getDocs(q);
    const records = [];
    
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      records.push({
        id: doc.id,
        ...data,
        timestamp: data.timestamp?.toDate ? data.timestamp.toDate() : new Date(data.timestamp)
      });
    });
    
    return records;
  } catch (error) {
    console.error('月別統計取得エラー:', error);
    throw error;
  }
}